module.exports = __webpack_public_path__ + "img/shopping.e0d7ad38.png";